export default "__VITE_ASSET__DV0qS7h___"